let timerId;

export default {
	show(text, type='info', dialog){
		if(dialog || (dyEditor && dyEditor.isDialog)){
			return uni.showToast({
				title	: text,
				icon	: 'none',
			});
		}
		
		let elem = document.querySelector('.top-toast');
		
		if(!elem){
			// document.body.innerHTML += `
			// 	<div class="top-toast error">
			// 		<span class="toast-info"></span>
			// 		<i class="iconfont icon-close-small toast-close" @click="dyEditor.toast.hide"></i>
			// 	</div>
			// `;
			// elem = document.querySelector('.top-toast');
			
			elem = document.createElement('div');
			elem.setAttribute('class', 'top-toast error');
			elem.innerHTML = `
				<span class="toast-info"></span>
				<i class="iconfont icon-close-small toast-close" @click="dyEditor.toast.hide"></i>
			`;
			
			document.body.appendChild(elem);
		}
		
		elem.querySelector('.toast-info').innerHTML = text;
		
		switch(type){
			case 'error':
				elem.setAttribute('class', 'top-toast error')
				break;
				
			default:
				elem.setAttribute('class', 'top-toast info')
				break;
		}
		elem.style.display = 'flex';
		timerId = setTimeout(()=>{
			this.hide();
		},3000);
	},
	
	success(text){
		this.show(text, 'info');
	},
	
	error(text){
		this.show(text, 'error');
	},
	
	hide(){
		let elem = document.querySelector('.top-toast');
		elem.style.display = 'none';
		if(timerId) {
			clearTimeout(timerId);
			timerId = null;
		}
	}
}